module.exports = __webpack_public_path__ + "img/slogan.67d2020b.png";